var locationMaps = [].slice.call(document.querySelectorAll('.map-container')),
	apiKey = 'AIzaSyAhK9y2OfggphwDjJhyxMZw2Y9SA0QTQWs';

if(locationMaps.length) {
	window.initMap = function() {
		locationMaps.forEach(function(mapElement) {
			initMap(mapElement);
		});
	};

	scriptWaypoint(locationMaps[0], 'https://maps.googleapis.com/maps/api/js?key='+apiKey+'&callback=initMap', '150%');
}

function initMap(mapElement) {
	var openWindow,
		currentMarker;

	axios.get('/map-section/'+mapElement.getAttribute('data-location')).then(function(r) {
		var locations = r.data.locations,
			center = JSON.parse('['+r.data.center+']'),
			// bounds = new google.maps.LatLngBounds(),
			mapOptions = {
				zoom: 13,
				streetViewControl: false, // hide the yellow Street View pegman
				scaleControl: true, // allow users to zoom the Google Map
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				scrollwheel: false,
				center: new google.maps.LatLng(center[0], center[1]),
				styles: mapStyles
			};

		map = new google.maps.Map(mapElement, mapOptions);

		locations.forEach(function(location) {
			var isLocationPage = location.openWindow,
				coordinates = JSON.parse('['+location.coordinates+']'),
				latLng = new google.maps.LatLng(coordinates[0], coordinates[1]),
				infowindow = new google.maps.InfoWindow({
					position: latLng,
					content: location.html
				}),
				markerSize = checkWidth(1024) ? 56 : 80,
				markerImage = new google.maps.MarkerImage(
					'/assets/images/icons/map-pin'+(checkWidth(1024) ? '-mobile' : '')+'.svg',
	                new google.maps.Size(markerSize, markerSize),
	                new google.maps.Point(0, 0),
	                new google.maps.Point(markerSize/2, markerSize/2)
                ),
				marker = new google.maps.Marker({
					map: map,
					position: latLng,
					draggable: false,
					animation: google.maps.Animation.DROP,
					icon: markerImage
				});

			// bounds.extend(marker.position);

			// if(!openWindow && !checkWidth(768)) {
			// 	infowindow.open(map, marker); // Remove this to close infowindow by default
			// 	openWindow = infowindow;

      		// 	currentMarker = marker;
			// }

			// infowindow.addListener('closeclick', function() {
	        // 	openWindow = false;
	        // });

	        // marker.addListener('click', function() {
	        // 	if(openWindow)
	        // 		openWindow.close();

	      	// 	if(currentMarker != marker) {
	      	// 		currentMarker = marker;

	      	// 		infowindow.open(map, marker);
	      	// 		openWindow = infowindow;
	      	// 	}
	      	// 	else {
	      	// 		openWindow = false;
	      	// 		currentMarker = false;
	      	// 	}
	        // });
		});

		// map.fitBounds(bounds);
	});
}